<template>
    <div class='row'>
        <div class="col-12 ph-2">
            <h3 class=''> <ico class='gray f4' icon="angle-right"></ico>  <span class='pl-2 dib'> {{ info.name }} </span> </h3>
            <hr />
         </div>
    </div>
</template>

<script>
export default {
    props:{
        info:{
            default:{name:""}
        }
    }
}
</script>


<style lang="stylus" scoped>

    .event-info{
        h2{
            color:cor-ciano;
        }
    }
</style>
